import { Controller } from 'stimulus'
import imgPlaceholder from '../images/img_placeholder.png'

export default class extends Controller {
  static targets = ['input', 'output', 'label', 'destroy', 'destroyed']

  connect() {
    const length = this.inputTargets.length
    for (let i = 0; i < length; i++) {
      this.inputTargets[i].addEventListener('change', e => this.preview(e))
      this.destroyTargets[i].addEventListener('click', e => this.destroy(e))
    }
  }

  preview(e) {
    const i = e.target.dataset.index || 0
    const files = this.inputTargets[i].files
    if (files) {
      const self = this
      const reader = new FileReader()
      reader.onload = (event) => {
        self.outputTargets[i].src = event.target.result
      }
      reader.readAsDataURL(files[0])
      this.labelTargets[i].textContent = files[0].name
      this.destroyedTargets[i].value = ''
    }
  }

  destroy(e) {
    const i = e.target.dataset.index || 0
    this.inputTargets[i].value = ''
    this.outputTargets[i].src = imgPlaceholder
    this.labelTargets[i].textContent = 'ファイルを選択'
    this.destroyedTargets[i].value = '1'
  }
}
